import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import axios from 'axios';
import { RELATED_PRODUCTS, X_TENANT_ID } from '../../common/ActionUrl';
import RelatedProductGrid from './RelatedProductGrid';

const RelatedProductSliderPromotional = ({ spaceBottomClass, category, product }) => {
  const [relatedProductsList, setRelatedProductsList] = useState([]);
  let loopslide = 4;
  if (relatedProductsList?.length) {
    if (relatedProductsList.length <= 4) {
      loopslide = relatedProductsList.length;
    }
  }
  const getRelatedProducts = async () => {
    let ids = [];
    let productIds = [];
    if (product?.RelatedProductArray) {
      let relatedProd = product?.RelatedProductArray?.[0];
      if (relatedProd?.RelatedProduct?.length > 0) {
        relatedProd.RelatedProduct.map((productData) => {
          ids.push(productData.pId);
          productIds.push(productData.productId);
        });
      }
      const requestOptions = {
        headers: { 'Content-Type': 'application/json', 'X-TENANT-ID': X_TENANT_ID },
      };
      await axios
        .post(RELATED_PRODUCTS, { ids: ids, productIds: productIds }, requestOptions)
        .then((res) => {
          if (res?.data) {
            const response = res.data;
            setRelatedProductsList(response);
          }
        })
        .catch((err) => {
          console.log('err', err);
        });
    }
  };

  useEffect(() => {
    getRelatedProducts();
  }, [product]);

  if (relatedProductsList?.length == 0) {
    return '';
  }
  return (
    <div className={`related-product-area ${spaceBottomClass ? spaceBottomClass : ''}`}>
      <div className="container mt-5">
        <div
          className="row"
          style={{
            borderBottom: '2px solid #a1a1a1',
          }}
        >
          <h5
            style={{
              margin: 'auto',
              fontStyle: 'italic',
              fontWeight: 'bold',
              color: '#a1a1a1',
            }}
          >
            {'Related Items'}
          </h5>
        </div>

        <div className="row">
          <RelatedProductGrid
            category={category}
            isProductSlider={true}
            centeredSlides={true}
            relatedProductsList={relatedProductsList}
            sliderClassName={relatedProductsList?.length > 4 ? 'swiper-slide' : ''}
          />
        </div>
      </div>
    </div>
  );
};

RelatedProductSliderPromotional.propTypes = {
  category: PropTypes.string,
  spaceBottomClass: PropTypes.string,
};

export default RelatedProductSliderPromotional;
